import React from 'react';
import { hasFeature } from 'utils/featureFlags';
import styles from './Upload.css';

import UploadComponent from './UploadComponent';

function Upload(props) {
  const increaseImportLimit = hasFeature('increase-import-recipe-feature-flag');
  const MAX_ITEM_ROW = increaseImportLimit ? 10000 : 2500;

  if (props.currentStep !== 3) {
    return null;
  }

  return (
    <div className={styles['container-content']}>
      <h4> Upload File </h4>
      <p>
        {' '}
        To improve performance, we can only process {MAX_ITEM_ROW} rows at a
        time.{' '}
      </p>
      <UploadComponent />
    </div>
  );
}

export default Upload;
